import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ConsolePanel } from '@/ui';
import { Icon } from '@/icons';

const Card = styled(ConsolePanel).attrs({ $surfaceRole: 'overlay' })`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 20px;
  h2 {
    margin: 0;
    font-size: ${({ theme }) => theme.fontSize.md};
  }
  p {
    margin: 0;
    color: ${({ theme }) => theme.color.textMuted};
    font-size: ${({ theme }) => theme.fontSize.sm};
    line-height: 1.5;
  }
  > svg {
    color: ${({ theme }) => theme.color.accentCyan};
  }
  a {
    color: ${({ theme }) => theme.color.textPrimary};
    padding: 8px 12px;
    border: 1px solid ${({ theme }) => theme.color.glassBorder};
    border-radius: ${({ theme }) => theme.radius.md};
    font-size: ${({ theme }) => theme.fontSize.xs};
    text-decoration: none;
  }
`;
export function DiscoveryPromo({ premium = false }: { premium?: boolean }) {
  return (
    <Card>
      <Icon name={premium ? 'crown' : 'compass'} size={28} />
      <h2>{premium ? 'Freedom is priceless.' : 'Find your people'}</h2>
      <p>
        {premium
          ? 'Support TruXSocial and make it your own.'
          : 'Communities, creators and conversations for a better tomorrow.'}
      </p>
      <Link to={premium ? '/premium' : '/communities'}>
        {premium ? 'Explore Premium' : 'Explore Communities'}
      </Link>
    </Card>
  );
}
